var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetropolitanaDiRomaLogoLineaB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgLineaMetRo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 604 299.6236",
    style: {
      enableBackground: "new 0 0 604 299.6236"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#ee2926;}\n\t.st2{fill:#0071bb;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metro di Roma - Linea B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "301.854,0 0.0925,0 0.0925,299.6236 301.7615,299.6236  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.854,299.6236H0V0h301.854V299.6236z M222.8504,56.3052h-36.3183l-35.6514,122.4093L115.5117,56.3052 H79.1009L25.8575,243.3144h35.6514l36.4156-123.1443l34.892,123.0518h18.0642h18.4439l34.703-123.0518l36.4108,123.1443h35.7479 L222.8504,56.3052z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 301.854,
    className: "st2",
    width: 302.146,
    height: 299.6236
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.0727,243.4361h-48.0106V55.9742h45.4405c35.4664,0,59.6153,15.2361,59.6153,49.7727 c0,23.5989-17.4947,35.7001-28.1453,39.4044c12.9336,3.2313,34.3225,16.3556,34.3225,44.7103 C515.295,232.1186,486.108,243.4361,452.0727,243.4361 M449.8871,79.7921h-11.6972v54.879h10.4608 c10.6458,0,26.2372-3.6849,26.2372-27.0501C474.8878,89.44,467.7566,79.7921,449.8871,79.7921 M450.3593,157.7005h-12.1694v61.5868 h15.2126c11.6964,0,27.2878-5.0868,27.2878-28.5493C480.6902,166.8762,470.0396,157.7005,450.3593,157.7005"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetropolitanaDiRomaLogoLineaB);
export default __webpack_public_path__ + "static/media/Metropolitana_di_Roma_-_logo_linea_B.8566b7b7184c2812b5f20e3e9eed7940.svg";
export { ForwardRef as ReactComponent };